import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.RULES_BREAKING].GET_RULES_BREAKING]: {
		url: '/company/:companyId/rule_breaking/',
	},
	[ModulesConfigMap[ModulesMap.RULES_BREAKING].GET_RULE_BREAKING]: {
		url: '/company/:companyId/rule_breaking/:ruleBreakingId/',
	},
}